/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PaymentFormData } from '../models/payment-form-data';
import { PaymentFormResponse } from '../models/payment-form-response';
import { TokenizeFormData } from '../models/tokenize-form-data';


/**
 * API for payment form to make E-Comm transactions
 */
@Injectable({
  providedIn: 'root',
})
export class PaymentFormService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation paymentFormPaymentIframeLink
   */
  static readonly PaymentFormPaymentIframeLinkPath = '/v1/payment-form/payment-iframe-link';

  /**
   * Request the Online Card Payment Form source.
   *
   * Use this endpoint to retrieve a URL, which will be used with iframe tag for making payments using the VituPay
   * JavaScript SDK - Online Payment Form.\
   * \
   * Permissions: core.iframe.create-sale
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentFormPaymentIframeLink()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentFormPaymentIframeLink$Response(params: {
    body: PaymentFormData
  }): Observable<StrictHttpResponse<PaymentFormResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentFormService.PaymentFormPaymentIframeLinkPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentFormResponse>;
      })
    );
  }

  /**
   * Request the Online Card Payment Form source.
   *
   * Use this endpoint to retrieve a URL, which will be used with iframe tag for making payments using the VituPay
   * JavaScript SDK - Online Payment Form.\
   * \
   * Permissions: core.iframe.create-sale
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paymentFormPaymentIframeLink$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentFormPaymentIframeLink(params: {
    body: PaymentFormData
  }): Observable<PaymentFormResponse> {

    return this.paymentFormPaymentIframeLink$Response(params).pipe(
      map((r: StrictHttpResponse<PaymentFormResponse>) => r.body as PaymentFormResponse)
    );
  }

  /**
   * Path part for operation paymentFormTokenizeIframeLink
   */
  static readonly PaymentFormTokenizeIframeLinkPath = '/v1/payment-form/tokenize-iframe-link';

  /**
   * Request the Online Card Payment Method Form source.
   *
   * Use this endpoint to retrieve a URL which will be used with iframe tag for generating payment method tokens using
   * the VituPay JavaScript SDK - Online Payment Form.\
   * \
   * Permissions: core.iframe.create-token
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentFormTokenizeIframeLink()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentFormTokenizeIframeLink$Response(params: {
    body: TokenizeFormData
  }): Observable<StrictHttpResponse<PaymentFormResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentFormService.PaymentFormTokenizeIframeLinkPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentFormResponse>;
      })
    );
  }

  /**
   * Request the Online Card Payment Method Form source.
   *
   * Use this endpoint to retrieve a URL which will be used with iframe tag for generating payment method tokens using
   * the VituPay JavaScript SDK - Online Payment Form.\
   * \
   * Permissions: core.iframe.create-token
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paymentFormTokenizeIframeLink$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentFormTokenizeIframeLink(params: {
    body: TokenizeFormData
  }): Observable<PaymentFormResponse> {

    return this.paymentFormTokenizeIframeLink$Response(params).pipe(
      map((r: StrictHttpResponse<PaymentFormResponse>) => r.body as PaymentFormResponse)
    );
  }

}
